import {Component} from '@angular/core';
import {downgradeComponent} from '@angular/upgrade/static';

declare const angular: angular.IAngularStatic;

@Component({
    templateUrl: './app-router-outlet.component.pug'
})
export class AppRouterOutletComponent {}

angular.module('app').directive('app2RouterOutlet',
    downgradeComponent({ component: AppRouterOutletComponent }));
